// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"21f4be14","159":"fde4d4b3","217":"3e8ceac9","237":"7d846a92","264":"fb38f497","404":"34d703fb","488":"d81bf076","498":"f60d82f1"}[chunkId] + ".chunk.js";
};